module.exports = __webpack_public_path__ + "static/media/orderDeclined.faa1b30f.webp";